import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ModalService } from 'src/app/common/services/modal/modal.service';
import { VisitorEvent } from 'src/app/modules/shared/models/visitor.event';
import { FancyEventDetailsModalComponent } from '../event.details.modal/fancy.event.details.modal/fancy.event.details.modal.component';
import { IEventDetailsModalData } from '../event.details.modal/event.details.modal.provider';

@Component({
  selector: 'ig-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss'],
})
export class TimelineComponent implements OnInit {
  @Input() events: VisitorEvent[];
  eventMap: IEventMap[] = [];

  @ViewChild('container', { static: false }) container: ElementRef;
  @ViewChild('card', { static: false }) card: ElementRef;

  isAtStart = true;
  isAtEnd = false;

  constructor(public modalService: ModalService) {}

  ngOnInit(): void {
    console.log(this.events);

    const map: IEventMap[] = [];
    this.events.forEach((event) => {
      event.eventTimes.forEach((eventTime) => {
        const key = this.getDateKey(eventTime);
        const time = this.getTime(eventTime);

        const exist = map.find((e) => e.key === key);
        if (exist) {
          !exist.events.includes(event) && exist.events.push(event);
        } else {
          map.push({
            key,
            time,
            events: [event],
          });
        }
      });
    });

    this.eventMap = map.sort((a, b) => {
      return a.time - b.time;
    });
    console.log('eventMap', this.eventMap);
  }

  getDateKey(time) {
    return `${time.month}.${time.day}`;
  }

  getTime(time) {
    return new Date(`${time.month}/${time.day}/${time.year}`).getTime();
  }

  goToEvent(event: VisitorEvent) {
    this.modalService.show({
      component: FancyEventDetailsModalComponent,
      panelClass: 'ig-modal-w-full',
      data: {
        currentEvent: event,
        allEvents: [],
        favCustomEvents: [],
        from: 'placeCalendar',
      } as IEventDetailsModalData,
    });
  }

  goRight() {
    const container = this.container.nativeElement;
    container.scrollLeft += this.getScrollWidth();
    this.checkIsAtStart();
    this.checkIsAtEnd();
  }
  goLeft() {
    const container = this.container.nativeElement;
    container.scrollLeft -= this.getScrollWidth();
    this.checkIsAtStart();
    this.checkIsAtEnd();
  }

  checkIsAtStart() {
    if (!this.container) return;
    setTimeout(() => {
      const { scrollLeft } = this.container.nativeElement;
      this.isAtStart = scrollLeft === 0;
    }, 800);
  }

  checkIsAtEnd() {
    if (!this.container) return;
    setTimeout(() => {
      const { scrollWidth, scrollLeft, clientWidth } =
        this.container.nativeElement;
      this.isAtEnd = scrollWidth - (scrollLeft + clientWidth) <= 10;
    }, 800);
  }

  getScrollWidth() {
    return this.container.nativeElement.getBoundingClientRect().width;
  }
}

interface IEventMap {
  key: string;
  time: number;
  events: VisitorEvent[];
}
